/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>View side (down the X axis)</h4>

<p>Switch view down the X axis. Click again to switch to opposite (-X) view direction.</p>

<p>Clicking on the orthogonal plane also flips view between X and -X direction</p>

<p>The up/down-arrow and left/right-arrow keys rotate view by 15 degrees.</p>`;

export default function ViewXTooltip() {
    return h('div', { innerHTML: body });
}
